module.exports = __webpack_public_path__ + "static/media/kfc-bucket.97a34ca8.png";